import Products from "../Products"
import Banner from "../components/Banner";


export default function AllProduct() {
    return (
        <div>
            <Banner />
            <Products />
        </div>
    )
}